export const plans = [
  {
    title: "Stater",
    Duration: "1 week",
    price: "$100-$500",
    min: "100",
    roi: "30%",
    offers: [
      "15 daily top up",
      "2000 max price",
      "30% interest",
      // "250% compound interest",
      "Hashrate 10ph/s",
      "10% profit bonus",
      "10% Referral bonus",
    ],
  },
  {
    title: "Basic",
    Duration: "1 week",
    price: "$1,000",
    min: "1000",
    roi: "30%",
    offers: [
      "20 daily top up",
      "4000 max price",
      "30% interest",
      // "50% compound interest",
      "Hashrate 10ph/s",
      "15% profit bonus",
    ],
  },
  {
    title: "Gold",
    Duration: "2 weeks",
    price: "$5,000",
    min: "5000",
    roi: "30%",
    offers: [
      "10 daily top up",
      "20000 max price",
      "30% interest",
      // "10% compound interest",
      "Hashrate 10ph/s",
      "10% profit bonus",
    ],
  },
  {
    title: "Sliver",
    Duration: "3 weeks",
    price: "$8,000",
    min: "8000",
    roi: "30%",
    offers: [
      "15 daily top up",
      "24000 max price",
      "30% interest",
      // "250% compound interest",
      "Hashrate 10ph/s",
      "30% profit bonus",
    ],
  },
  {
    title: "Standard",
    Duration: "1 month",
    price: "$10,000",
    min: "10000",
    roi: "30%",
    offers: [
      "20 daily top up",
      "32000 max price",
      "30% interest",
      // "30% compound interest",
      "Hashrate 10ph/s",
      "30% profit bonus",
    ],
  },
  {
    title: "VIP",
    Duration: "2 Months",
    price: "$20,000",
    min: "20000",
    roi: "35%",
    offers: [
      "20 daily top up",
      "55000 max price",
      "35% interest",
      // "35% compound interest",
      "Hashrate 10ph/s",
      "35% profit bonus",
    ],
  },
];
